export const educationData = [
    {
        id: 1,
        institution: 'Masai School Bangalore',
        course: 'Full Stack web-developer',
        startYear: 'OCT 2021 ',
        endYear: ' AUG 2022'
    },
    {
        id: 2,
        institution: 'Government Polytechnic Ghaziabad',
        course: 'Information Technology',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'G D B I C Gotpur Mainpuri UP',
        course: 'Intermediate',
        startYear: '2015',
        endYear: '2017'
    },
]